import React from 'react';
import { GetServerSideProps } from 'next';
import { Profile, ProfileController, State, withCookie } from '@oward/openapi';
import HtmlHead from '@components/HtmlHead';
import { getLocaleProps, LocaleProps, WithLocale } from '@components/I18n';
import { WithAuthentication, getAuthenticationProps, AuthenticationProps } from '@components/Authentication';
import { WithNavbar } from '@components/NavBar';
import { AccountProfilesPage } from '@components/Pages/Account';
import { GDPR, PopUp, OwardModals, PageWrapper } from '@components/.';
import LoginOrErrorOrPage from '@components/Pages/Common/LoginOrErrorOrPage';

interface PageProps {
  profiles?: Profile[];
  errorMsg?: string;
  notLogged?: boolean;
}

export const getServerSideProps: GetServerSideProps = async context => {
  let pageProps: PageProps;
  const locale = context.params.lang as string;
  const localeProps = await getLocaleProps(locale);
  const authenticationProps = await getAuthenticationProps(context);

  if (authenticationProps.currentUser === null) {
    pageProps = { notLogged: true }
  }
  else {
    let cookie = context.req.headers.cookie;
    try {
      let profiles: Profile[] = await withCookie(cookie)(ProfileController.findForUser(locale))
      pageProps = {
        profiles: profiles.filter(profile => profile.state !== State.DELETED)
      }
    }
    catch (error) {
      pageProps = { errorMsg: (error as Error)?.message }
    }
  }

  return {
    props: {
      ...pageProps,
      ...authenticationProps,
      ...localeProps
    }
  }
}

const Page: React.FC<PageProps> = props => {
  return (
    <PageWrapper>
      <LoginOrErrorOrPage
        errorMsg={props.errorMsg}
        notLogged={props.notLogged}
      >
        <AccountProfilesPage profiles={props.profiles} />
      </LoginOrErrorOrPage>
    </PageWrapper>
  );
}

const CompletePage: React.FC<PageProps & LocaleProps & AuthenticationProps> = props => {
  return (
    <WithLocale {...props}>
      <WithAuthentication {...props}>
        <Page {...props} />
      </WithAuthentication>
    </WithLocale>
  );
}

export default CompletePage;


